import ajax from "../assets/uilt/ajax";

let transactionLimit = {
  /**get transaction limit list */
  getList: (req) => {
    return ajax.get({
      url: "/back/transaction-limit/get-list",
      param: req.param,
      success: req.success,
    });
  },

  update: (req) => {
    return ajax.get({
      url: "/back/transaction-limit/update-amount-limit",
      param: req.param,
      success: req.success,
    });
  },
};

export default transactionLimit;
